// Removes `<tag ...>` / `</tag>` mention markers from a string while keeping
// the inner name visible. Used when a chat title or other display surface
// would otherwise leak raw wire markers — including truncated titles where
// only the opening `<tag ...>` survived the cut.
const MENTION_TAG_MARKER = /<\/?tag(?:\s[^>]*)?>/g;

export const stripMentionTags = (text: string | null | undefined): string =>
  text ? text.replace(MENTION_TAG_MARKER, '') : '';
